import { RightOutlined } from '@ant-design/icons';
import { Routes } from 'business/router/constants';
import { createSearchParams, Link } from 'react-router';

export const RepairEntry = ({
  defectId,
  date,
  label,
  serialNumber,
  segmentType,
}: {
  defectId: string;
  date: string;
  label: string;
  serialNumber: string;
  segmentType: string;
}) => {
  return (
    <Link
      to={`${Routes.ReceiptRepair}?${createSearchParams({ id: defectId, serialNumber, segmentType })}`}
      className="flex w-full justify-between rounded-xl border border-gray-200 p-4"
    >
      <div className="w-1/3 shrink-0 text-black">{date}</div>
      <div className="min-w-0 flex-1 truncate text-black">{label}</div>

      <RightOutlined className="shrink-0 pr-2 text-xl text-black" />
    </Link>
  );
};
